// src/pages/admin/dropdownOptions.js
const dropdownOptions = {
    category: [
        { value: 'Homepage', label: '首頁' },
        { value: 'About', label: '關於我們' },
        { value: 'Church Leader', label: '教會領袖' },
        { value: 'Main Theme', label: '教會主題' },
        { value: 'Contact', label: '聯絡我們' },
        { value: 'Meet Pastor', label: '於牧者面對面' },
        { value: 'Pastor', label: '牧者' },
    ],
    target: [
        { value: '1', label: '管理員' },
        { value: '2', label: '組長' },
        { value: '3', label: '對外開放' },
    ],
};

module.exports = dropdownOptions;